import axios from "axios"
import { API_BASE_URL } from "../config"

const createReview = async (data) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/trips/review`, data);

        return res.data;
    }
    catch (err) {
        return err.message;
    }
}

const getAllReviews = async ()=>{
    try {
        const res = await axios.get(`${API_BASE_URL}/trips/reviews`);

    return res.data;
    }
    catch (err) {
        return;
    }
}

const deleteReview = async (id) => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/trips/review/${id}`);
        return {status: "success", data: res.data}
    }
    catch (err) {
        return {status: "error", message: err}
    }
}
export { createReview, getAllReviews, deleteReview }